/** @internal */
export const OP_CONSTANT = "Constant";
/** @internal */
export const OP_FAIL = "Fail";
/** @internal */
export const OP_FALLBACK = "Fallback";
/** @internal */
export const OP_DESCRIBED = "Described";
/** @internal */
export const OP_LAZY = "Lazy";
/** @internal */
export const OP_MAP_OR_FAIL = "MapOrFail";
/** @internal */
export const OP_NESTED = "Nested";
/** @internal */
export const OP_PRIMITIVE = "Primitive";
/** @internal */
export const OP_SEQUENCE = "Sequence";
/** @internal */
export const OP_HASHMAP = "HashMap";
/** @internal */
export const OP_ZIP_WITH = "ZipWith";
//# sourceMappingURL=config.js.map